export default {
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_EURO: "Euro",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_RUR: "Rubles",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_RUR_EQ: "Ruble equivalent",
    ACCOUNT_BALANCE_REPORT_COLUMN_TITLE_REMAINS_USD: "Dollars",
    Cancel: "Cancel",
    Error: "Error",
    Event: "Event",
    No: "No",
    RATE_EXPENSES_REQUEST_SCHEME_ACTUAL: "Work scheme (act)",
    RATE_EXPENSES_REQUEST_SCHEME_EXPECTED: "Work scheme (est)",
    Settings: "Settings",
    TRANSFER_UNIT_ROUTE: "Route",
    Tasks: "Tasks",
    Warning: "Warning",
    Yes: "Yes",
    "You should add at least one contact person": "Alt least one contact person is needed",
    account_currency_is_not_specified:
        "Account currency is not specified<br>Recalculation of multi-currency accounts will not be made",
    account_operations_modal_title: "Account operations",
    currency_account_operations_modal_title: "Card foreign currency accounts",
    add: "Add",
    add_company_link: "Choose new counterpart",
    add_invoice_button_text__payment_order_form: "Add an invoice",
    add_new_role_placeholder: "Add a new role",
    add_tab_invoice_form: "Add a service",
    add_transfer_arrival_point: "Add a route point",
    add_transfer_button_text__transfer_unit_form: "Add a sgoulder",
    add_transfer_link_button_text__transfer_unit_form: "Attach to shoulder",
    add_transfer_units_to_forwarding: "Add cargo units",
    add_units_invoice_form: "Add items",
    add_user_button_text: "Add user",
    add_warehouse_link: "Choose new route point",
    add_order_fin_operation: "Add fin. the operation of this order",
    add_fin_operation: "Add fin. operation",
    admi_modal_title: "Administration",
    admin_item_title_menu: "Menu",
    admin_item_title_roles: "Roles",
    admin_item_title_users: "Users",
    all: "All",
    all_operaions_must_have_account: "All operatation must have invoice attached",
    all_operations_must_have_one_currency: "All operations must be in one currency",
    all_transfer_unit_in_select_row_winodw: "All",
    are_you_ready_clear_scheme_in_order: "Do you want to clear your scheme?",
    arrival_map_days_1: "Day",
    arrival_map_days_2: "Day",
    arrival_map_days_5: "Days",
    arrival_map_not_found: "Nothing found",
    arrival_map_vessel: "Vessel",
    arrival_map_voyage: "Flight",
    attach_file_title: "File",
    attach_target_title: "Objects",
    back: "Back",
    batch_fin_operation_buy_title: "Batch purchase fin. operations {- composite_name }",
    before_submit_error: "Error in beforeSubmit",
    validate_error: "Error data validation",
    binding_failed_in_a_car_transaction_only_one_link_load_to_one_document:
        "Linking is not done: you can assign only 1 cargo unit to 1 document in tucking operation",
    btn_all_text: "Add all",
    calc_tax_error_code_100: "Failed to get data of HS code",
    calc_tax_error_code_110: "Limit of requests for this user is over",
    calc_tax_error_code_200: "The information on this HS code is not found, a non-existent commodity code",
    calc_tax_error_code_201: "You must specify the net weight",
    calc_tax_error_code_210: "Failed to get data of HS code",
    calc_tax_error_code_220: "The code is not valid for requested date",
    calc_tax_error_code_250: "Country code not found",
    calendar_item_view_more: "More ",
    calendar_modal_title: "Calendar",
    cam_photo_item_select: "Select",
    cam_settings_modal_title: "Camera settings",
    cam_settings_proporion: "Enter the proportion of the image, for example 16/9",
    cancel_button: "Cancel",
    cant_remove_billed_transaction: "You cannot delete a transaction with issued invoice",
    cant_remove_mirror_incoming_invoices: "You cannot remove the mirror account: {= invoices}",
    cant_remove_orders_with_invoices:
        "You cannot delete orders with issued outgoing invoices or registered outgoing invoices",
    cfm_all_text: "(Choose everything)",
    change_desktop_wallpapers: "Change wallpapers",
    change_operation_unit_order_confirm_choose_order_after_destroy_unit_links: "No links left. Continue?",
    change_operation_unit_order_error_details_fin_opers_title: "Financial transactions:",
    change_operation_unit_order_error_details_gtds_title: "Customs Declaration:",
    change_operation_unit_order_error_details_invoices_at: "from",
    change_operation_unit_order_error_details_invoices_title: "Invoices:",
    change_operation_unit_order_error_details_log_doc_opers_title: "Docs of logistics operations:",
    change_operation_unit_order_error_details_log_opers_title: "Logistics operations:",
    change_operation_unit_order_error_details_title: "It is necessary to decouple the cargo unit from:",
    change_operation_unit_order_error_text: "It is impossible to decouple the cargo unit from this order",
    chat_clear_history_confirm: "Are you sure you want to delete these messages?",
    chat_clear_history_confirm_ok_text: "Delete",
    chat_create_room_name_placeholder: "Group's name",
    chat_create_room_selected_1: "participant",
    chat_create_room_selected_2: "participants",
    chat_create_room_selected_5: "participant",
    chat_last_seen_prefix: "Last seen ",
    chat_leave_room_confirm: "Do you want to leave this group?",
    chat_leave_room_confirm_ok_text: "To leave",
    chat_never_seen: "Not seen",
    chat_no_last_message_text: "Writing...",
    chat_room: "Room",
    chat_room_edit_list_clear_history: "Clean",
    chat_room_edit_list_leave: "To leave",
    chat_room_edit_list_mute: "Switch off notifications",
    chat_room_edit_list_unmute: "Switch in notifications",
    chat_room_settings: "Settings",
    chat_room_settings_title: "Group: ",
    chat_rooms_create_input_placeholder: "Enter a new group's name",
    chat_row_room_title: "Chats: {table}#{id}",
    chat_search_counter__not_found: "No matches",
    chat_search_counter__of: "from",
    chat_search_placeholder: "Search",
    chat_select_dialog: "Please select a chat",
    chat_unreaded_startup_two_description: "Unread meassages: {count}",
    chat_unreaded_startup_two_title: "New messages",
    chat_user: "User",
    chat_user_online: "Online",
    chat_you: "You",
    choose: "Choose",
    choose_access_doc: "Choose",
    choose_file_from_device: "Choose a file",
    choose_gtd: "Choose",
    choose_order_gtd_form_btn_text: "Choose order",
    choose_unit: "Choose",
    clear: "Clear",
    clear_contract_data: "Are you sure you want to update {=records_qunatity} records?",
    clear_grid_list: "Reset",
    client_gtd_by_year__cleared_count: "Customs cleared",
    client_gtd_by_year__conditional_cleared_count: "Customs preliminarily cleared",
    client_gtd_by_year__release_for_procured_count: "Customs cleared under deposit",
    client_gtd_by_year__days_to_clear_avg: "Days for customs clearance",
    client_gtd_by_year__payments_sum: "Total payments",
    client_gtd_by_year__recalled_count: "Withdrawn",
    client_gtd_by_year__refused_count: "Rejected",
    client_gtd_by_year__total_in_row: "Total",
    client_gtd_by_year__total_row_name: "Total",
    client_gtd_by_year_direction__ex: "Export",
    client_gtd_by_year_direction__im: "Import",
    client_gtd_by_year_direction__tt: "Transit",
    client_gtd_by_year_direction__unknown: "(Without direction)",
    client_gtd_by_year_unknown_gtd_point: "(No customs)",
    client_gtd_by_year_unknown_gtd_post: "(Untitled)",
    clipboard_bad_support_copy: "Your browser does not support 'copy to clipboard' function",
    clipboard_copy_prompt_text: "Insert text into feild then press ОК",
    clone_units_confirm_text_invoice_form: "Do you want to add all items to the tab?",
    close_all_apps: "Close all",
    close_button: "Close",
    column_auto_width: "Auto column width",
    apply_button: "Apply",
    reset_button: "Reset",
    column_filter_menu_null_values_title: "Empty",
    column_filter_menu_common_search_placeholder: "Search...",
    column_filter_menu_delimited_search_placeholder: "Search by {=uniqueValuesNumber} values",
    column_filter_menu_title: "Filters:",
    combine_operations: "Console cargoes",
    company_form_create_point_link: "To create",
    company_form_select_point: "Choose",
    confirm_delete_and_replace_on_double: "To remove and replace double entry ?",
    confirm_edit_rate_expenses:
        "During quatation editing data will change in all depending work schemes. Are you sure you want to edit the quatation?",
    confirm_restore_row: "Are you certain you want to restore the line?",
    confirm_restore_rows: "Are you certain you want to restore lines?",
    contextmenu_open_file: "Open",
    conversion_rate_is_absent: "Conversion rate is absent",
    copy: "Copy",
    copy_order_confirmation_text:
        "Copying from request can cause a loss of privios filled in information.<br>Are you sure you want to continue?",
    copy_order_data_from_request: "Copy information from request",
    copy_order_warning_text: "Please choose a request to copy data from",
    country_name_rus: "Russia",
    create: "Create",
    create_access_doc: "Create",
    create_gtd: "Create",
    create_for_all_invoice_positions: "Create for all items of invoice",
    create_incoming: "Register incoming payment",
    create_incoming_btn_text_transfer_unit_form: "Create incoming invoice",
    create_incoming_by_fin_operation_btn_text_transfer_doc_form: "Incoming invoice (as per fin. operation docs)",
    create_incoming_by_fin_operation_btn_text_transfer_unit_form: "Incoming invoice (as per fin. operations)",
    create_incoming_money_btn_text_transfer_unit_form: "Incoming cash",
    create_incoming_money_by_fin_operation_btn_text_transfer_doc_form: "Incoming cash (as per fin. operation docs)",
    create_incoming_money_by_fin_operation_btn_text_transfer_unit_form: "Incoming cash (as per fin. operation)",
    create_invoice_by_fin_operations_multi_contractors_error: "You cannot create invoice with different counterparties",
    create_invoice_by_fin_operations_multi_payers_error: "You cannot create invoice with different payers",
    create_order_by_declaration_gtd_btn_text: "Create order",
    create_outgoing: "To create outgoing payment",
    create_outgoing_btn_text_transfer_unit_form: "Create outgoing invoice",
    create_outgoing_by_fin_operation_btn_text_transfer_doc_form: "Outgoing invoice (as per fin. operation docs)",
    create_outgoing_by_fin_operation_btn_text_transfer_unit_form: "Outgoing invoice (as per fin. operation)",
    create_outgoing_money_btn_text_transfer_unit_form: "Outgoing cash payment",
    create_outgoing_money_by_fin_operation_btn_text_transfer_doc_form: "Outgoing cash (as per fin. operation docs)",
    create_outgoing_money_by_fin_operation_btn_text_transfer_unit_form: "Outgoing cash payment (as per fin. operation)",
    create_report: "Create a report",
    create_row: "Create",
    create_unit: "To create",
    crm_notification_template:
        "Type: {= escapeHtml(COMPANY_CRM_EVENT_TYPE_NAME)} - {= timestamp2userdate(EXPECTED_DATE_APPLY)}<br/>Company: {= escapeHtml( LIST_COMPANY_NAME || EVENTS_LIST_COMPANY_NAME )}<br/>link type: {= escapeHtml( COMPANY_CRM_EVENT_CONNECTION_TYPE_NAME )}<br/>contact: {= escapeHtml( LIST_CONTACT_PERSONS_CONTACT_PERSON )}<br/>{= (ROW_OBJECT ? 'Object:' + escapeHtml(ROW_OBJECT) : \")}<br/>",
    create_with_selecting_invoice_positions: "To creat specifying invoice items",
    crm_notification_title: "CRM event reminder",
    crm_request_source: "Source",
    crm_request_status: "Status",
    crm_request_type: "View",
    curator: "Curator",
    currency_of_order_differs_currency_of_account:
        "The order currency differs from the account currency<br>When choosing a payment in a currency other than the account currency<br>you need to set the conversion rate for the day of payment",
    current_transfer_unit_in_select_row_winodw: "In this place",
    disable_reason: "Fill in the previous date!",
    data_changes_log: "Log",
    date_repeat_every_day: "Every day",
    date_repeat_every_month: "Every month",
    date_repeat_every_week: "Every week",
    date_repeat_every_weekdays: "During weekdays",
    date_repeat_every_year: "Annually",
    date_repeat_no_select: "No chosen",
    debit_or_credit_must_be_more_then_zero: "Debit and credit of the at least two operation must be filled",
    default_confirm_window_title: "Confirmation",
    delete: "Delete",
    delete_cell: "Delete cell",
    delete_cells: "Delete data",
    delete_row: "Delete a row",
    delete_rows: "Delete lines",
    detach_gtd_units_confirm: "Do you want to untie cargo units?",
    detach_gtd_units_confirm_ok_text: "Untie cargo units",
    no_units_detach_gtd_error: "No cargo in customs declaration",
    detach_order_gtd_form_btn_text: "Untie the order",
    do_not_show_tooltip: "Do not show",
    download: "Download",
    drag_here: "Drag here сюда or <span>select</span>",
    dt_create_field_title: "Entry creation date",
    edit_rate_expenses: "Change quatation",
    edit_row: "Edit",
    edit_user_modal_title: "User",
    email_was_send: "Letter was sent",
    enter_curs_prompt_text_invoice_form: "Enter exchange rate",
    enter_summ_prompt_text_invoice_form: "Enter amount",
    enter_text_tooltip: "Enter text",
    error_file_download: "Failed to download file",
    error_big_excel_download: "Exceeded the maximum allowable number of rows for uploading (10 000).",
    export_prepare_declaration_title: "Uploading of cargo declaration",
    exclude_credit_note_from_payments_sum: "Show overpayment?",
    filters_text: "Add a filter",
    fin_buy: "Purchase",
    fin_clone: "Copy",
    fin_details_percent_must_be_less_or_equal_then_100: "Sum of % cannot exeede 100",
    fin_operation_buy_title: "Fin. operation purchase {- composite_name }",
    fin_operation_sale_title: "Fin. the operation sale {- composite_name }",
    fin_operationy_disable: "Fin. transaction(and/or)sale already listed. Prohibited bulk insert of values",
    fin_operationy_disable_pay: "Checkbox \"Purchases recorded\" marked, you cannot edit or add.",
    fin_operationy_disable_sale: "Checkbox \"Sales recorded\" marked, you cannot adit or add.",
    fin_operationy_disable_invoice: "You can't delete fin.operation with recorded invoices.",
    fin_renominate: "Redraw",
    fin_sale: "Sale",
    fin_sale_by_log_oper: "Sale in Logistics plan",
    find_rate_expenses: "Find quatations",
    form_required_field_error: "You must fill in the item",
    full_remove: "Delete irretrievably",
    full_remove_row_confirm: "Are you sure you want to delete the line irretrievably?",
    full_remove_rows_confirm: "Are you sure you want to delete the lines irretrievably?",
    fullscreen_map: "Open the map",
    get_reason_cancel_user_task: "Enter reason for deviation in comments",
    total_gross_weight_title: "Gross weight",
    gtd_load_error_event_notify_template:
        "Failed to download Declaration number {= row.GTD_NUMBER}, reason: {= row.DESCRIPTION}",
    gtd_order_already_exists: "Are you sure you wish to replace existing order #{order_id}?",
    gtd_success_loaded_event_notify_template:
        "Declaration number {= row.GTD_NUMBER}, new entry #{= row.ID_GTD} successfuly uploaded.",
    gtd_success_updated_event_notify_template:
        "Declaration number {= row.GTD_NUMBER}, record #{= row.ID_GTD} successfully updated record.",
    hide_column: "Hide column",
    hour_short_name: "h",
    import_invalid_file: "To import only the available files with the extension: ",
    import_loading_files: "File loading",
    import_loading_files_complete: "Loading is complete",
    import_prepare_declaration_title: "Download of Customs declaration draft",
    importance_1: "Low",
    importance_2: "Usual",
    importance_3: "Urgent",
    industrial_assembly_code: "HS code (Prom. Assembly)",
    initial_tooltip_mathes_text: "Similar records: 0",
    inn: "ITN",
    invalid_name: "Name cannot be empty",
    invoice_confirm_transform_to_simple_money_3: "Are you sure you want to record incoming cash reciept?",
    invoice_confirm_transform_to_simple_money_4: "Are you sure you want to record outgoing cash expence?",
    invoice_form_add_rate_expense_type: "Add service",
    invoice_form_add_simple_position: "Add position",
    invoice_form_add_units: "Add cargo units",
    invoice_form_choose_payment: "Select payment record",
    invoice_form_choose_cash: "Select cash payment",
    invoice_form_choose_swift: "Select SWIFT",
    invoice_form_company_title: "Counterpart",
    invoice_form_copy_row: "Copy",
    invoice_form_create_payment: "Create payment record",
    invoice_form_create_cash: "Create cash payment",
    invoice_form_create_swift: "Create SWIFT",
    invoice_form_payer_title: "Payer",
    invoice_form_remains: "Balance:",
    invoice_form_totals: "Total:",
    invoicing: "Invoicing",
    remains: "Balance",
    totals: "Total:",
    is_archive_order_or_crm_error: "You can't edit archived records",
    is_invoice_date_error: "You can't edin invoice with current date of Act",
    is_archive_order: "You can't edit archived invoice",
    late_invoices_credit_modal_title: "Accounts payable",
    late_invoices_debit_modal_title: "Accounts recievables",
    late_invoices_unknown_company: "(Not specified)",
    late_invoices_unknown_currency: "(Not specified)",
    linked_company_doc_number_masks_to_company: "Templates account numbers:",
    linked_contracts_fea_to_company: "Foreign trade contracts:",
    linked_contracts_to_company: "Contracts:",
    linked_crms_to_company: "Inquiries:",
    linked_dog_schemes_to_company: "Templates of documentary schemes:",
    linked_log_schemes_to_company: "Logistics templates:",
    linked_objects_to_company: "Object, where counterparty will be replaced:",
    linked_objects_to_point: "Object, where routing point will be replaced:",
    linked_orders_to_company: "Orders:",
    linked_payment_orders_to_company: "Recieved/Paid payments:",
    linked_request_currency_translations_to_company: "Currency transfers:",
    linked_sea_rates_to_company: "Sea quotes",
    linked_units_to_company: "Cargoes:",
    ldm_total_title: "LDM",
    lng_add: "Add",
    lng_clear: "Clear",
    local_rating_title_driver_form: "The last",
    log_operationy_disable_or_deleted: "Check \"Purchases recorded\" (and/or) \"Sales recorded\", you can't add or edit.",
    log_operationy_disable: "Check \"Purchases recorded\" (and/or) \"Sales recorded\", you can't add.",
    matches_count: "Quantity of similar records: ",
    max_100_add_transfer_units: "You cannot add over 100 units at a time",
    menu_edit_title: "Setup menu",
    menu_item_edit_title: "Setup menu",
    message_box_placeholder: "Write a message",
    min_all_apps: "Hide all",
    min_width_all_columns: "Stretch all columns",
    min_width_column: "Stretch column",
    minute_short_name: "m",
    modal_title_new_row: "New entry",
    model_rating_title_driver_form: "Transportation rating",
    month_start: "Beginning of the month",
    multi_add_transfer_unit_button_title: "Add several units",
    multi_currency_payments:
        "Multi-currency payments<br>After choosing a payment in a currency other than the account currency,<br>you need to set the conversion rate on the day of payment",
    must_selected_packing_positions: "You need to select lines in two tables for repacking",
    need_save_form: "You must save the form",
    need_select_company_in_crm_form: "You need to choose counterparty",
    total_netto_weight_title: "Net weight",
    new_chat_message: "New message",
    new_chat_message_noty_title: "New message in chat",
    new_task_noty_title: "New task",
    no_chat_contacts: "No users",
    no_chat_dialogs: "No active dialogs",
    no_chat_messages: "No messages",
    no_chat_rooms: "No groups",
    no_comments: "No comments",
    no_dialogs_search_messages: "Messages not found",
    no_filters_text: "No filters",
    no_photo_text: "Upload a photo",
    no_route_ata_date_driver_form: "Data is not filled",
    not_found: "Nothing found",
    not_found_fields: "Nothing was found",
    notification_template_accept_task_with_comment: "{comment.message}",
    notification_template_task_comment: "{comment.message}",
    ok: "OK",
    ok_clear_scheme_in_order: "Clear the scheme",
    operation_air: "Air",
    operation_auto: "Trucking",
    operation_by_object_title: "Financial transaction object \"{= query}\" #{= id}",
    operation_customs: "Customs",
    operation_must_have_account_currency: "Currency of the operation does not match curerncy of the invoice",
    operation_not_allowed: "Insufficient permissions to perform the operation.",
    operation_request_scheme_task__parallel: "Parallel",
    operation_request_scheme_task__prev: "Previous",
    operation_request_scheme_task__series: "Subsequent",
    operation_sea: "Sea",
    operation_train: "Railway",
    operation_type_name_auto: "Trucking",
    operation_unit_from_part_number_create: "Create",
    operation_unit_from_part_number_select: "Choose",
    operations_summ_must_be_equal_zero: "Operations amount must be zero",
    operations_task_sea_like_auto: "Sea (shipped separately)",
    order_docs_email_error: "Error when sending mail",
    order_docs_email_success: "Letters will be sent soon",
    order_docs_email_wait_previous_sending: "Wait until previouse mail will be sent",
    order_has_no_units_related_to_declaration:
        "Failed to compare numbers of loading units of the order and Declaration. Are you sure you want to bind Declaration to this order?",
    order_position_quantity_over_max: "Maximum possible value: {= max - otherPositionsSum}",
    order_position_quantity_over_min: "The minimum possible value is: {= min}",
    order_profit_by_oper_type_by_year__fin_sum_buy: "Purchase",
    order_profit_by_oper_type_by_year__fin_sum_diff: "Profit",
    order_profit_by_oper_type_by_year__fin_sum_sale: "Sale",
    order_profit_by_oper_type_by_year__inv_sum_buy: "Purchase",
    order_profit_by_oper_type_by_year__inv_sum_diff: "Profit",
    order_profit_by_oper_type_by_year__inv_sum_sale: "Sale",
    order_profit_by_oper_type_by_year__no_oper_type: "(Without type)",
    order_profit_by_oper_type_by_year__total: "Total",
    order_profit_by_oper_type_by_year_value_group__fact: "Fact",
    order_profit_by_oper_type_by_year_value_group__plan: "Plan",
    order_type_AIR: "Air",
    order_type_FCL: "FCL",
    order_type_FTL: "FTL",
    order_type_LAL: "LAL",
    order_type_LCL: "LCL",
    order_type_LCL_export: "LCL export",
    order_type_LCL_import: "LCL import",
    order_type_LRL: "LRL",
    order_type_LTL: "LTL",
    order_type_TRAIN: "Railway",
    order_units_by_year__fin_sum: "Margin plan",
    order_units_by_year__inv_sum: "Margin fact",
    order_units_by_year__orders_count: "Number of orders",
    order_units_by_year__total_in_row: "Total",
    order_units_by_year__total_row_name: "Total",
    order_units_by_year__units_count: "Number of cargo units",
    order_units_by_year_direction__1: "Import",
    order_units_by_year_direction__2: "Export",
    order_units_by_year_direction__3: "Internal",
    order_units_by_year_direction__4: "Transit",
    order_units_by_year_direction__unknown: "(Without direction)",
    order_units_by_year_unknown_order_type: "(Without type)",
    order_units_create_menu_choose: "Choose",
    order_units_create_menu_choose_owner_unit_empty: "Choose empty",
    order_units_create_menu_choose_owner_unit_freight: "Choose loaded",
    order_units_create_menu_create: "Create",
    order_units_create_menu_create_batch: "Batch creation",
    order_without_client: "You cannot create order. You need to change the status for a potential client.",
    owner_unit_point_address: "Address",
    pass1_less_then_6: "The password contains less than 6 characters",
    pass1_not_equal_pass2: "Entered password do not match",
    password_tooltip: "The password must contain at least 6 characters",
    paste: "Paste",
    paste_row_not_found: "A line to insert is not found",
    paste_type_error: "Data types do not match <br/> impossible to insert data",
    payment_order_form_remains: "Balance:",
    payment_order_form_totals: "Total:",
    placeholder_enter_text: "Enter text",
    please_enable_cam: "Please, turn the camera on",
    please_select_operation: "Please select operations",
    please_select_operation_type: "Please select type of operation",
    plugin_only_from_form: "The plugin is designed only for form",
    print_btn_text: "Print",
    quantity_total_title: "Number of cargo places",
    rate_expenses_default_rur: "RUB",
    read_notification_read_all: "Read all",
    delete_group_chat: "Delete a group chat",
    read_notification_read_selection: "Read selected",
    receive_new_task_notifications: "New tasks",
    receive_task_action_notifications: "Actions to tasks",
    receive_task_comment_notifications: "Comments to tasks",
    receive_unload_in_port_notifications: "Unloading in the port",
    user_profile_notify_settings: "Notification settings",
    received_payment_order: "Recieved payment",
    reminder_picker_checkbox_line_text_duration_10: "10 minutes",
    reminder_picker_checkbox_line_text_duration_10080: "week",
    reminder_picker_checkbox_line_text_duration_1440: "day",
    reminder_picker_checkbox_line_text_duration_30: "30 minutes",
    reminder_picker_checkbox_line_text_duration_60: "hour",
    remove_desktop_icon: "delete the tag",
    remove_desktop_icon_confirm_text: "Are you sure you want to delete the tag?",
    remove_invoice_btn_text_invoice_form: "Delete the invoice",
    remove_invoice_confirm_text_invoice_form: "Are you sure you want to delete the invoice?",
    remove_invoice_position_renominate_warning:
        "This position was reimbursed in the invoice #{=RENOMINATION_INVOICE_TO}.<br> Are you sure you want to remove this line?",
    remove_invoice_renominate_warning:
        "This document has reimbursed expenses: {=RENOMINATION_LINK}. Are you sure you want to delete the document?",
    remove_position_invoice_form: "Delete row",
    remove_row_confirm: "Are you certain that you want to delete the line?",
    remove_rows_confirm: "Are you sure you want to delete the lines?",
    remove_selected_confirm: "Are you sure you want to delete the data?",
    remove_tab_confirm_text_invoice_form: "Are you sure you want to delete the tab with all items?",
    remove_tab_invoice_form: "Delete service",
    remove_transfer_button_text__transfer_unit_form: "Delete transportation shoulder",
    remove_transfer_confirm_text__transfer_unit_form: "Are you sure you want to delete this transportation shoulder?",
    remove_transfer_link_button_text__transfer_unit_form: "Detach transportation shoulder",
    remove_transfer_link_confirm_text__transfer_unit_form:
        "Are you sure you want to detach this transportation shoulder?",
    rename_desktop_icon: "rename",
    renomination_all_invoice: "The entire bill",
    renomination_check_need_outgoing_yesno: "Reimbursed marked only?",
    renomination_checked_positions: "Marked position",
    renomination_invoice_btn_text_invoice_form: "Invoice forwarding",
    renomination_invoices: "Reimburse expenses",
    repackgin_form_modal_title: "Cargo units repacking",
    reports_updated: "Reports were updated",
    require_payer: "You must fill in the following item: Payer",
    cannot_update_reports: "Cannot update reports",
    cannot_edit_treasury_value: "Value received from treasury cannot be edited",
    request_auto_comment_on_update: "Alteractions",
    required_invoice_mask: "You need to fill in the mask",
    req_create: "Create",
    req_clone: "Copy",
    clone: "Copy",
    restore: "Restore",
    row_locked_by_other_user: "The entry is worked with by another user",
    row_was_deleted_text: "Row is deleted",
    row_was_restored_text: "Row is restored",
    safe_column_error: "Column \"{=column}\" cannot be edited",
    safe_row_edit_error: "Row \"{=row}\" cannot be edited. {reason}",
    save_before_close: "Save changes?",
    save_button: "Save",
    scheme_add_point: "Add waypoint",
    select: "Select",
    select_all: "Select all",
    select_rate_expenses: "Choose current",
    selected_packing_positions_must_be_valid: "Net weight, Gross weight and quantity have to be above zero",
    selected_units_are_from_different_orders: "You can select goods from only one order",
    selection_total_quantity: "Quantity",
    selection_total_sum: "Amount",
    send_data_by_email: "Send by e-mail",
    sent_payment_order: "Sent payment",
    server_error_delete_rows: "Server error occured while deleting <br/> Try again later",
    set_curs_invoice_form: "Currency rate",
    set_summ_invoice_form: "Amount",
    shipment_export_cargo_print_addition_btn_text: "Addition",
    shipment_export_cargo_print_btn_text: "Print",
    show_last_selected_point_on_map: "Back to the last selected point",
    sometype: "Type",
    sort_mode_context_item_title_off: "Sorting is off",
    sort_mode_context_item_title_on: "Sorting is on",
    success_calc_order_gtd_tax: "Duty: {= GTD_TAX} VAT: {= GTD_PREPAYMENT}",
    success_calc_order_gtd_tax_title: "New values",
    success_change_password: "New password is saved",
    success_send_auto_messages: "Messages were sent",
    sum_payment_actual_limit: "You cannot indicate amount exceeding total amount of payment ",
    sum_payment_maximum_limit: "Amount of payment exceeds amount due",
    sum_payment_zero_limit: "The payment amount must not be negative",
    sys_notifications_startup_two_description: "Unread notifications: {count}",
    sys_notifications_unreaded_startup_two_title: "New notifications",
    system_delegate_user_task_notification_template:
        "Type: {= escapeHtml(NOTIFICATIONS_TYPE_NAME)}<br/>User: {= escapeHtml( LIST_USER_NAME_CREATE )}<br/>{= (NEW_USER_EXECUTOR_FULL_NAME ? ('New action:' + NEW_USER_EXECUTOR_FULL_NAME) : \")}<br/>{= (ROW_OBJECT ? ('Object:' + escapeHtml(ROW_OBJECT)) : \")}<br/>{= (MESSAGE ? ('Message:' + escapeHtml(MESSAGE)) : \")}",
    system_notification_template:
        "Type: {escapeHtml(NOTIFICATIONS_TYPE_NAME)}<br/>User: {escapeHtml( LIST_USER_NAME_CREATE )}<br/>{if(ROW_OBJECT, 'Object: ' + escapeHtml(ROW_OBJECT), '')}<br/>{if(MESSAGE, 'Message: ' + escapeHtml(MESSAGE), '')}",
    system_notification_title: "Notifications",
    table_no_rows: "No records",
    table_tab_confirm_remove_text: "Delete tab: ",
    table_tab_confirm_title: "Tab removal",
    tabs_all_title: "All",
    tabs_delivered_title: "Delivered",
    tabs_inProgress_title: "In progress",
    task_accept_action_text: "Accept",
    task_accept_with_comment_action_text: "Принять с комментарием",
    task_actions_button_text: "To do",
    task_delegate_action_text: "Delegate",
    task_finish_action_text: "Finish",
    task_pause_action_text: "Freeze",
    task_reject_action_text: "Decline",
    task_resume_action_text: "Restart",
    tasks_unreaded_startup_two_description: "Unread tasks: {count}",
    tasks_unreaded_startup_two_title: "New tasks",
    thank: "Thank you",
    time_type: "Days/Hours",
    time_type_days: "Days",
    time_type_hours: "Watch",
    timelength_d: "d",
    timelength_h: "h",
    timelength_m: "m",
    today: "Today",
    toolbar_account_remains: "Balance",
    total: "Total",
    total_rating_title_driver_form: "General rating",
    total_row_text: "Total:",
    total_text_transfer_unit_form:
        "Profit: {currencySpaces(round2(rub, 2))} (RUB) or {currencySpaces(round2(usd, 2))} (USD) or {currencySpaces(round2(eur, 2))} (EUR)",
    transfer_all_company_group_name: "Counterparties",
    transfer_request_attach_user_notification_template:
        "You have been added to the request #{= row.ID_GTD}: {= row.NAME}",
    transfer_request_default_name_prefix: "Request",
    transfer_unit_form__type_menu__air: "Air",
    transfer_unit_form__type_menu__auto: "Road",
    transfer_unit_form__type_menu__customs: "Customs",
    transfer_unit_form__type_menu__forward: "Forwarding",
    transfer_unit_form__type_menu__sea: "MArine",
    transfer_unit_form__type_menu__train: "Rail",
    trash: "Trashbin",
    trash_show: "Show basket",
    uimodal_toggle_details: "Read more",
    uniq_error_invoice_doc_date_company: "There is invoice #{=ID} with the same number, date, and counterparties",
    unit_in_move: "On the way",
    unit_in_point: "At the station",
    unit_switch_off_tracking_btn_text: "Remove from tracking",
    unit_switch_on_tracking_btn_text: "Put on tracking",
    unit_without_expected_date: "(No date)",
    unit_without_type: "(Without type)",
    unknown: "Error unknown",
    unknown_option_title: "Unknown header",
    unpacking_grid_must_have_selection_for_return: "Необходимо выделить строку в развале справо",
    unselect_all: "Cancel all",
    upload_files: "Upload files",
    user_added_task: "by",
    user_added_task_: "task",
    user_create_field_title: "Record owner",
    user_profile_email: "E-mail",
    user_profile_email_placeholder: "Enter your e-mail",
    user_profile_password: "Password",
    user_profile_password_repeat: "Repeat password",
    user_profile_password_success_change_text: "Your password is successfully changed",
    user_profile_password_success_change_title: "Change password",
    user_profile_phone: "Phone",
    user_profile_phone2: "Phone 2",
    user_profile_phone_placeholder: "Enter the phone number",
    user_profile_save_pass: "Save password",
    user_role_modal__roles_title: "Roles",
    user_role_modal__users_title: "Users",
    user_task_create_by_template: "Template",
    user_task_dates: "Period",
    user_task_description: "Description",
    user_task_reference: "Object",
    user_task_show_all: "Tasks (all)",
    user_task_show_archive: "Task (archive)",
    user_task_show_current: "Tasks (in process)",
    user_task_simple_create: "New",
    user_task_theme: "Topic",
    user_task_was_delegated_to: "Task delegated to the user: {= new_user_full_name}",
    users: "Users",
    users_table_select_count_text: "Selected users",
    usual_code: "HS code",
    vat: "VAT",
    volume_total_title: "Volume",
    walpers_modal_title: "Desktop wallpapers",
    wallpapers_modal_title: "Desktop wallpapers",
    weak_required_elem: "You must fill in the item",
    week_start: "Beginning of the week",
    weight_groups_mismatch: "Names of product group does no match with indicated in the Contract",
    word_to_search: "Search phrase",
    year_start: "Beginning of the year",
    client_payment_balance__unknown_currency: "(Not specified)",
    client_payment_balance__begin_balance_name: "Starting balance",
    auto_created_and_mirror_payment_error: "You cannot edit automatically created or mirror payment orders",
    mirror_payment_error: "You cannot edit mirror payment orders",
    confirm_before_paste: "Do you want to insert data into the table?",
    grid_list_help: "Help",
    grid_list_any_role: "Fits any role",
    grid_list_help_alert_title: "Suitable roles",
    grid_list_roles: "Role",
    supplier_company: "Supplier",
    broker_company: "Customs broker",
    get_docs_from_supplier: "Receiving documents from supplier",
    manufacturer: "Manufacturer",
    operation_base_elements__docs: "Documents",
    operation_base_elements__route: "Route",
    operation_base_elements__operations: "Operations",
    change_currency_of_invoice_with_payment_order_error:
        "You cannot change the currency in settled invoice (Payment was recorded).",
    unique_LIST_COMPANY_inn: "Counterparty with this Tax Id was already entered.",
    no_order_id: "You cannot create cargo units without the order ID",
    invoice_all_positions_insert_clipboard_error: "You need to add the service",
    dont_touch_begin_transfer: "You cannot edit or delete the transaction opening balance",
    partner: "Partner",
    consignee: "Consignee",
    contract_number: "Contract number",
    reference: "Reference",
    unit_record_number: "Cargo units ID numbers",
    unit_number: "Cargo unit number",
    group_number: "Console cargoes numbers",
    quantity: "Number of cargo places",
    net_weight: "Net weight",
    gross_weight: "Gross weight",
    packaging_type: "Packing type",
    dt_terminal_name: "Customs clearance station",
    point_cbx_name: "Customs terminal of arrival",
    min_date_gtd_clear_expected: "Estimated customs clearance date",
    contract_type: "Contract type",
    declaration_kind: "Declaration type",
    crm_name: "Inquiry name",
    delivery_conditions: "Delivery terms",
    quantity_expected: "Quantity plan",
    unit_type_expected: "Cargo units type (as planned)",
    arrival_point_first: "First route point",
    arrival_point_last: "Last route point",
    date_loading: "Pick up planned for",
    date_delivery: "Delivery planned for",
    quantity_units_and_owner_plan: "Planned units quantity, types and owners",
    quantity_units_and_owner_fact: "Actual units quantity, types and owners",
    ship_arrival_date_plan_for_loading: "Planned date the vessel arrives for loading",
    list_name_weight_name: "Commodity",
    point_port_start_name: "Port of departure",
    booking_number: "Booking numbers",
    point_start_name: "Pick up place",
    point_end_name: "Delivery place",
    quantity_pallet: "Number of pallets",
    order_type_name: "Order type",
    unit_division_name: "Cargo type",
    vessel_name: "Feeder vessel",
    operations_names: "Scheme",
    name_error: "Matches by name",
    website_error: "Matches by website",
    phone_error: "Matches by phone",
    company_trashed_error: "The counterparty is in the basket",
    collision_error: "These fields match the existing record",
    company_already_exists: "Company already exists",
    Container: "Container",
    old_log_scheme_operations_have_invoices: "There are invoices issued based on previous Logistics plan",
    unable_to_select_log_scheme:
        "You cannot select a new log. the scheme as checkbox \"Purchase is listed\" (and/or) \"Sale recorded\" ticked.",
    unable_clear_rates_invoices_exists: "You cannot clear rates as invoices were already issued",
    unable_clear_rates_sales_or_buys_are_recorded_:
        "You cannot clear rates as checkbox \"Buy listed\" (and/or) \"Sale recorded\" marked.",
    dont_remove_invoice: "You cannot delete invoice with recorded links",
    create_transfer__note: "Note",
    create_driver: "Create",
    choose_driver: "Choose",
    create_auto: "Create",
    choose_auto: "Choose",
    Tk: "Customs Card",
    capital_account_balance_total: "Total:",
    head_of_the_farm: "Head of farming entreprise",
    IP: "Businessman",
    invoices_is_not_create: "Declaration does not meet requirements for invoicing acc to template",
    cost_of_the_pattern: "Charge expences using template",
    yesterday: "Yesterday",
    week_day_sn: "Sun",
    week_day_m: "Mon",
    week_day_t: "Tue",
    week_day_w: "Wed",
    week_day_th: "Thu",
    week_day_f: "Fri",
    week_day_s: "Sat",
    no_edit_unit_in_renomination_invoice: "You cannot edit cargo unit when expences charged",
    Remove: "Delete",
    Unlink: "Untie",
    remove_or_unlink: "Are you sure you want to delete/to untie this string?",
    choose_action: "Select action",
    has_forward_operation: "Port forwarding",
    x5__supply_orders: "Orders",
    x5__orders_all: "Supplies (all)",
    x5__orders_archive: "Supplies (archive)",
    x5__orders_current: "Supplies (in progress)",
    dont_touch_not_new_supply_order: "You cannot change or delete confirmed order",
    use_plugin_only_for_forms: "The plugin is designed only for forms",
    get_reason_reject_supply_order: "Enter the reason in the comments",
    get_reason_recall_supply_order: "Enter the reason in the comments",
    cannot_recall_working_supply_order: "Cannot recall Order with registered supplies",
    cannot_reject_working_supply_order: "Cannot reject Order with registered supplies",
    no_save_sea_rates_duplicates:
        "Some quotes with the same parameters were previously saved. They will not be saved again.",
    single_start_point_if_more_than_one_end_point:
        "You cannot select more than one departure if you have selected more than one destination",
    single_end_point_if_more_than_one_start_point:
        "You cannot select more than one destination if you have selected more than one place of departure",
    create_single_sea_rate: "Add a quote",
    create_multiple_sea_rate: "Bulk add quotes",
    every_supply_order_should_have_same_status: "All orders must have the same status",
    choose_all_time_find_analogue: "For all time",
    choose_3_month_find_analogue: "For the three months",
    els: "ELS",
    tk: "customs card",
    every_supply_order_should_have_filled:
        "Order {= order_number } you must fill in the required fields: <br/>{= required_fields}",
    every_supply_order_should_have_valid_positions_count:
        "Order {= order_number } the number of containers/TS must be equal to the number of positions",
    every_supply_order_should_have_valid_positions_plu:
        "Order {= order_number } all positions must have the same product",
    every_supply_order_should_have_positions: "Order {= order_number } you need to fill the position",
    every_supply_order_should_have_position_filled:
        "Order {= order_number } fill the position of: <br/>{= required_fields}",
    kg: "kg",
    confirm_kick_another_user: "This account is already in use.<br/>to Continue the login?",
    user_another_login: "Cancel",
    continue_kick: "Log",
    somebody_try_login: "Another user tries to log in under your account",
    somebody_kick_you: "Another user came in under your account",
    login: "Log",
    no_unique_list_company_name: "You cannot restore because the counterparty with the same name",
    pre_detach_all_attached_units: "To the customs Declaration attached to the goods. To unlink them or leave?",
    save_attached_units_and_orders: "Leave",
    detach_attached_units_and_orders: "Detach",
    choose_from_attached_orders_ask:
        "For new loading unit to select the order from attached to the Customs Declaration?",
    choose_from_attached_orders: "From attached",
    choose_from_all_orders: "All",
    choose_from_attached_order_ask: "For new loading units to choose the order attached to the Customs Declaration?",
    choose_from_attached_order: "Choose attached order",
    choose_from_all_orders2: "Choose from all orders",
    create_new_order_ask: "For new loading unit to create a new order?",
    create_new_order: "To create a new order",
    choose_from_all_orders3: "To choose from the available",
    date_rates_ends_expired:
        "For some selected transactions<br> have expired rates.<br> Update the dates of these rates?",
    clear_expired_date_rates_ends_and_init_date_rates_starts_by_now: "Update date",
    keep_existing_dates_rates_starts: "Do not update",
    customs_nomenclature_type_name: "Customs duties",
    rights_name__toolbar: "Toolbar",
    rights_name__columns: "Columns",
    rights_name__filters: "Filters",
    rights_name__own_rows: "Their records",
    rights_name__department_rows: "The Department records",
    rights_name__roles: "The role",
    rights_name__other: "The rest",
    rights_name__form: "Form",
    rights_name__form_reports: "Forms",
    rights_name__form_generate_reports: "Generate reports",
    rights_name__form_buttons: "Button",
    rights_name__grid_head: "Hat",
    rights_name__create_log_oper: "The create operation",
    rights_name__comments: "Comments",
    rights_name__empty_exclusive: "(Empty)",
    rights_name__log_oper_route: "Route",
    cant_remove_part_number_with_archive_unit: "You cannot delete invoices that are linked to the archival goods",
    notChooseBlockInvoice: "You must select at least one block to transfer",
    form_elements_need_defined_size: "Form elements need to know the size in which the form opens",
    no_model_no_form: "No model - no forms",
    paramsby_need_eid: "paramsBy necessary for eid",
    eid_reserved: "You cannot use this eid (reserved by system)",
    eid_must_be_ubique: "Property eid must be unique, found repeat",
    prepayment_report__name: "Name",
    prepayment_report__date: "Date",
    prepayment_report__company: "Company",
    prepayment_report__debet: "Debit",
    prepayment_report__credit: "Credit",
    prepayment_report__note: "Note",
    prepayment_report__some_vat: "VAT {= vat_value }",
    prepayment_report__vat__without_vat: "Without VAT",
    prepayment_report__vat__unknown_vat: "VAT is not specified",
    prepayment_report__begin_balance_name: "Beginning balance",
    date_not_provided: "(date not specified)",
    from: "from",
    notChooseAnalogue: "You must select the line to be transferred.",
    unit_number_is_incorrect: "The field \"Cargo unit\" must contain only Latin",
    logoper_train_sub_doc_app: "Overhead railway",
    must_first_apply_the_changes: "First you need to apply the changes",
    chat_clear_history: "Clear history",
    chat_unmute: "Enable notifications",
    chat_mute: "Disable notifications",
    chat_read_all: "Read all",
    chat_set_as_read: "To mark as read",
    chat_set_as_unread: "Mark unread",
    chat_open_link: "Open",
    chat_download_link: "Download",
    chat_remove_message: "To remove",
    chat_remove_message_for_all_users: "To remove all",
    chat_clipboard_copy: "To remove all",
    reason_for_working_with_company: "With the counterparty the work was resumed for the following reasons:",
    reason_for_stop_working_with_company: "With the counterparty the work is terminated for the following reasons:",
    help_for_doc_number_generator:
        "\n <div>Current value:</div>\n <div class='current-value' style='height:17px'>&nbsp;</div>\n<br/>\n\n <div>Input mask example:</div>\n <div>MSK-<b>{dd}</b>/<b>{mm}</b>/<b>{yyyy}</b> <b>{vacant of month, start 5000}</b></div>\n <div>MSK-09/10/2017 5019</div>\n<br/>\n\n <div>Input mask types:</div>\n<br/>\n\n<div>Counterparty:</div>\n <div><b>{company_name}</b> counterparty name</div>\n<br/>\n\n<div>Dates:</div>\n <div><b>{dd}</b> day, 01 or 31</div>\n <div><b>{mm}</b> month, 01 or 12</div>\n <div><b>{yy}</b> year, 98, or 18</div>\n <div><b>{yyyy}</b> year, 2018</div>\n<br/>\n\n <div>Entry ID (unique identifier):</div>\n<div><b>{id}</b></div>\n<br/>\n\n <div>Sequence number within an interval:</div>\n <div><b>{# of day}</b> number within a day</div>\n <div><b>{# of month}</b> number within a month</div>\n <div><b>{# of year}</b> number within a year</div>\n <div><b>{# of day, start 1000}</b> number within a day plus 1000</div>\n <div><b>{# of month, start 1000}</b> number within a month plus 1000</div>\n <div><b>{# of year, start 1000}</b> number within a year plus 1000</div>\n <div><b>{# of year, zero 000}</b> number within a year with leading zeros, example: 001</div>\n <div><b>{# of year, zero 0000, start 50}</b> number within a year, plus 50 with leading zeros, example: 0051</div>\n<br/>\n\n <div>Vacant number within an interval:</div>\n <div><b>{vacant of day}</b> number within a day</div>\n <div><b>{vacant of month}</b> number within a month</div>\n <div><b>{vacant of year}</b> number within a year</div>\n <div><b>{vacant of day, start 1000}</b> number within a day plus 1000</div>\n <div><b>{vacant of month, start 1000}</b> number within a month plus 1000</div>\n <div><b>{vacant of year, start 1000}</b> number within a year plus 1000</div>\n <div><b>{vacant of year, zero 000}</b> number within a year with leading zeros, example: 001</div>\n <div><b>{vacant of year, zero 0000, start 50}</b> number within a year, plus 50 with leading zeros, example: 0051</div>\n<br/>\n<br/>\n<br/>\n\n <div>Sequence numbers following one another can't be used without a non-numeric separator.</div>\n<br/>\n\n <div><b>Incorrect masks examples:</b></div>\n <div>MSK-<b>{# of month<u style='color:red'>}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>1</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>12</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>999</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{id}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{dd}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{mm}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{yyyy}{</u># of day}</b> </div>\n<br/>\n\n <div><b>Correct masks examples:</b></div>\n <div>MSK-<b>{# of month<u style='color:green'>}/{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:green'>}-{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:green'>} {</u># of day}</b> </div>\n\n ",
    help_for_doc_number_generator_order:
        "\n <div>Current value:</div>\n <div class='current-value' style='height:17px'>&nbsp;</div>\n<br/>\n\n <div>Input mask example:</div>\n <div>MSK-<b>{dd}</b>/<b>{mm}</b>/<b>{yyyy}</b> <b>{vacant of month, start 5000}</b></div>\n <div>MSK-09/10/2017 5019</div>\n<br/>\n\n <div>Input mask types:</div>\n<br/>\n\n<div>Counterparty:</div>\n <div><b>{company_name}</b> counterparty name</div>\n <div><b>{company_name_small}</b> counterparty counterparty short name</div>\n<br/>\n\n <div>Managers:</div>\n<div><b>{operations_manager_initials}</b> Operations manager initials</div>\n<br/>\n\n <div>Dates:</div>\n <div><b>{dd}</b> day, 01 or 31</div>\n <div><b>{mm}</b> month, 01-12</div>\n <div><b>{yy}</b> year, 98, or 18</div>\n <div><b>{yyyy}</b> year, 2018</div>\n<br/>\n\n <div>Entry ID (unique identifier):</div>\n<div><b>{id}</b></div>\n<br/>\n\n <div>Sequence number within an interval:</div>\n <div><b>{# of day}</b> number within a day</div>\n <div><b>{# of month}</b> number within a month</div>\n <div><b>{# of year}</b> number within a year</div>\n <div><b>{# of day, start 1000}</b> number within a day plus 1000</div>\n <div><b>{# of month, start 1000}</b> number within a month plus 1000</div>\n <div><b>{# of year, start 1000}</b> number within a year plus 1000</div>\n <div><b>{# of year, zero 000}</b> number within a year with leading zeros, example: 001</div>\n <div><b>{# of year, zero 0000, start 50}</b> number within a year, plus 50 with leading zeros, example: 0051</div>\n<br/>\n\n <div>Vacant number within an interval:</div>\n <div><b>{vacant of day}</b> number within a day</div>\n <div><b>{vacant of month}</b> number within a month</div>\n <div><b>{vacant of year}</b> number within a year</div>\n <div><b>{vacant of day, start 1000}</b> number within a day plus 1000</div>\n <div><b>{vacant of month, start 1000}</b> number within a month plus 1000</div>\n <div><b>{vacant of year, start 1000}</b> number within a year plus 1000</div>\n <div><b>{vacant of year, zero 000}</b> number within a year with leading zeros, example: 001</div>\n <div><b>{vacant of year, zero 0000, start 50}</b> number within a year, plus 50 with leading zeros, example: 0051</div>\n<br/>\n<br/>\n<br/>\n\n <div>Sequence numbers following one another can't be used without a non-numeric separator.</div>\n<br/>\n\n <div><b>Incorrect masks examples:</b></div>\n <div>MSK-<b>{# of month<u style='color:red'>}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>1</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>12</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}</u><u style='color:red'>999</u>{# of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{id}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{dd}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{mm}{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:red'>}{yyyy}{</u># of day}</b> </div>\n<br/>\n\n <div><b>Correct masks examples:</b></div>\n <div>MSK-<b>{# of month<u style='color:green'>}/{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:green'>}-{</u># of day}</b> </div>\n <div>MSK-<b>{# of month<u style='color:green'>} {</u># of day}</b> </div>\n\n ",
    help_for_doc_number_generator_train:
        "\n <h4>Input mask example:</h4>\n<p>\n OLD <b>{vacant of mask}</b></b>\n</p>\n\n <h4>Valid elements of mask:</h4>\n <ul>\n <li>\n <b>{id}</b> is the Number of records in the database.\n</li>\n <li>\n <b>{vacant of mask}</b> - Vacant room within the mask.\n</li>\n <li>\n <b>{vacant of mask, start 10}</b> - Vacant room within the mask, indicating minimum values.\n</li>\n</ul>\n ",
    name_column: "Name",
    date_column: "Date",
    note_column: "Note",
    credit_column: "Credit",
    debit_column: "Debit",
    our_company_name_column: "The counterparty",
    company_column: "Company",
    company_client_column: "The client",
    company_partner_column: "Partner",
    crm_source_request_name: "The source of the referral",
    ddt_row_number: "The line number",
    ddt_finished_loading: "Download complete",
    ddt_loaded_with_errors: "Error when downloading files",
    cannot_remove_fin_oper_with_invoices: "You can't remove the fin.operation for which the invoice",
    invoice_without_doc_number: " account number (undefined)",
    ztm_validate_position: "Position",
    late_invoices_orders_numbers: "Order numbers",
    late_invoices_units_numbers: "The number of packages",
    late_invoices_invoice_date: "Invoice date",
    late_invoices_planned_statement_date: "Planned statement date",
    late_invoices_pay_date: "Payment term",
    late_invoices_max_pay_date: "Date of the debt",
    late_invoices_expected_pay_date: "Plan. payment date",
    late_invoices_date_send_closed_docs: "The date of sending the closing documents",
    late_invoices_date_sent_invoice_to_customer: "The date of sending the invoice to the client",
    late_invoices_statement_number: "Act number",
    late_invoices_statement_date: "Act date",
    late_invoices_sum_late_all: "Amount with delay",
    late_invoices_sum_without_late: "Amount without delay",
    late_invoices_less_14_days: "< 14 days",
    late_invoices_less_30_days: "< 30 days",
    late_invoices_less_45_days: "< 45 days",
    late_invoices_less_60_days: "< 60 days",
    late_invoices_less_90_days: "< 90 days",
    late_invoices_less_120_days: "< 120 days",
    late_invoices_less_180_days: "< 180 days",
    late_invoices_less_365_days: "< 365 days",
    late_invoices_more_365_days: "> 365 days",
    late_invoices_total: "Total",
    late_invoices_lated: "Expired",
    user_is_not_manager:
        "User {= name } is not a Manager of this company.<br>Please select the checkbox to the left of the user name",
    broker_contract: "contract agent",
    import_document_update_current_rows_question:
        "To update existing items? (Yes, new will not be created, undo - will create a new one)",
    order_docs_email_need_select_docs: "Not selected documents to send in the column \"Send\"",
    order_docs_email_send: "Send",
    order_docs_email_send_logic_1: "Newsletter 1",
    order_docs_email_send_logic_2: "Newsletter 2",
    order_docs_email_need_doc_type: "Not the selected document type",
    order_docs_email_need_gtd_file: "Should be an attached file, the name of which is the number of dt(figure 21).",
    ztm_invalid_order: "The order does not match the status \"New\":",
    cannot_remove_part_number_with_invoices: "You cannot delete an invoice for which the invoice",
    order_profit_by_oper_type_by_year__number_by_client: "Reference",
    order_profit_by_oper_type_by_year__order_number: "Order number",
    order_profit_by_oper_type_by_year__cbx_date: "Date of arrival at the warehouse/terminal",
    packing_task_quantity: "Number",
    pk_card: "PC",
    payments_by_bank__profits: "Profit",
    payments_by_bank__spends: "Losses",
    payments_by_bank__unknown_value: "(Not set)",
    payments_by_bank__no_name: "(Untitled)",
    payments_by_bank__total: "Total",
    payments_by_bank__main_total: "Total",
    payments_by_bank__rate_type: "Article",
    do_you_wanna_run_all_business_processes: "To run all business processes?",
    tp_els__duty_pay: "Payments Duty",
    tp_els__prepay: "Payments Advance",
    tp_els__payments_other_taxes: "Payments Other duties",
    tp_els__duty_remains: "Balance Duty",
    tp_els__remains_prepay: "Balance Advance",
    tp_els__remains_other_taxes: "Balance Other duties",
    tp_els__liq_duty: "Liquidity Duty",
    tp_els__liq_prepay: "Liquidity Advance",
    tp_els__liq_other_taxes: "Liquidity Other duties",
    tp_els__pays: "Payments",
    tp_els__remains: "The rest",
    tp_els__liq: "Liquidity",
    tp_els__other_taxes: "Other duties",
    tp_els__pk_card: "customs card",
    form_error__permissions_denied: "You have not enough rights",
    form_error__deleted_object: "The object is removed",
    close_all_noty: "Close all",
    doc_type_for_pay: "Invoice",
    waybill: "TTN",
    cell_editor_permission_denied: "No access rights",
    role_form_menu: "Menu",
    role_form_settings: "Settings",
    import_payment_file_result:
        "Loaded {= total } statements.\nCreated {= incomingCount } received PP.\nCreated {= outgoingCount } sent PP.\nAlready existed {= existCount } PP.",
    has_archive_units: "has archive units {= units }",
    has_duplicate_category: "has_duplicate_category {= names }",
    ztm_invalid_values: "Incorrectly filled fields: ",
    unit_has_no_exped: "The cargo is a no-op Forwarding",
    unit_has_no_sea: "Of the load no Maritime operation",
    operation_is_not_chosen: "Please select the operation",
    order_units_by_year__gross_weight: "The weight of the load",
    order_units_by_year__quantity: "Number of seats",
    order_units_by_year__fin_oper_sum_buy_with_vat: "Spending plan",
    order_units_by_year__inv_pos_sum_buy_with_vat: "Costs fact",
    order_units_by_year__fin_oper_sum_sale_with_vat: "Revenue plan",
    order_units_by_year__inv_pos_sum_sale_with_vat: "Revenue fact",
    order_units_by_year__profitability: "Profitability %",
    order_units_by_year__list_delivery_conditions_name: "Delivery terms",
    order_units_by_year__sys_serial_number: "Order number",
    cannot_save_if_day_start_is_more_than_day_end:
        "Error! End day cannot be earlier than start day.<br>Exception: if You want to specify that this rate is valid on all subsequent days, put the value of the 'date of expiry' zero (0).",
    cannot_save_if_date_start_is_more_than_date_end:
        "Error!<br>Expiry date may be earlier than the date of commencement of betting action.",
    port_terminal: "Port terminal",
    container_terminal: "Container terminal",
    contract_type_agent: "Agency",
    forbidden_to_edit: "It is forbidden to edit",
    rates_of_buy: "Quotes for purchases",
    dont_copy: "Prohibited copying",
    sarmant_yug: "OOO \"sarmant-South\"",
    check_the_vat_type_and_rate: "Check the correctness of the type and rate of VAT",
    appoint_assistants: "Assign assistants orders",
    delete_assistants: "To remove assistants orders",
    appoint_managers: "Assign managers to companies",
    delete_managers: "Remove managers from companies",
    appoint_roles: "Assign roles",
    delete_roles: "Remove roles",
    appoint_employees: "Appoint employees on accounts",
    delete_employees: "Remove employees on accounts",
    date_start_more_date_end: "Error! End date cannot be earlier than start date.",
    order_units_by_year_direction__null: "Not filled direction",
    payload_too_large: "The uploaded file is too large. Please reduce the amount of data to upload.",
    not_unique_mmsi: "This MMSI already in use",
    not_unique_bik: "The BIC is already in use",
    order_requests_are_copied_in_the_background:
        "Going up commercial proposals<br>a Copy is in the background<br>and may take some time.",
    is_agency: "Agency",
    need_agency_type_contract:
        "In the account are perivitelline position.<br> you Should select the contract type is \"Agent\"",
    list_EDI_events: "The list of events EDI",
    table_title: "Table",
    broken_part_number_positions: "In some positions was not designed TP Duty. Read more?",
    date_received_is_not_same: "Даты получения разные - изменение заблокировано",
    on_order_has_not_sea_operation: "На заказе отсутствует Морская операция",
    clients_list_text: "Clients",
    containers: "Cargo units numbers",
    invoice_doc_number: "Invoice",
    orders_numbers: "Orders numbers",
    orders_references: "References",
    rate_expense_type_names: "List of service items",
    create_single_owner_unit: "Добавить подвижной состав",
    create_multiple_owner_unit: "Пакетное добавление подвижного состава",
    quantity_must_be_more_0: "Количество подвижного состава должно быть больше 0",
    invoice_positions_validation_error: "You must fill in {= columns}",
    customers_or_suppliers_checkbox: "Необходимо указать роли контрагентов",
    counterparty_balance_report: "Баланс с контрагентами",
    on_order_has_not_feeder: "На заказе отсутствует Фидерный коносамент",
    empty_invoce_statement_number_or_date_error: "In order the present account numbers and/or dates of the act",
    calc_storage_rates__required_fields_error:
        "Необходимо заполнить поля: <br/> {= datePortIncoming}{= datePortOutgoing}{= dateReturnEmpty}{= companySeaLineId}{= unitTypeId} ",
    datePortIncoming: "Date of arrival",
    datePortOutgoing: "&nbsp;date of export,",
    dateReturnEmpty: "&nbsp;the date of delivery of the container",
    companySeaLineId: "&nbsp;Line,",
    unitTypeId: "&nbsp;the Type of cargo unit&nbsp;",
    calc_storage_rates__required_fields_error2:
        "You must fill the fields: <br/> date of arrival, date of export, the date of delivery of the container, the Line, the Type of cargo unit",
    disabled_consignment_types_are_not_allowed: "Необходимо указать тип коносамента",
    CURRENCY_NAME: "Currency",
    has_closed_docs: ", the invoice already has closing documents",
    is_mirror: " in a mirror invoice",
    LIST_COMPANY_CATEGORY: "Category",
    is_closing_documents_issue: ", closing documents are being prepaired",
    statement_date_less_than_date_in_fin_settings_equals_1: ", the invoice belongs to a closed period",
    mirror_1: " in a mirror invoice",
    has_closed_docs_equals_1: ", the invoice already has closing documents",
    has_1c_unload_1: "invoice unloaded into 1с",
    archived_order_equals_1: ", the invoice is attached to an archived order",
    archived_order: ", the invoice is attached to an archived order",
    forbidden_to_inline_edit: "You have no permission to edit \"{= key}\"{= message}",
    edit_field_invoice_status_1c_is_loaded_error:
        "Edit {field= field } from account {= invoiceId} is not allowed because the status of discharge in 1C Unloaded",
    forbidden_to_remove_tab_by_filter:
        "You have no permission to remove tabs{= filterKey}",
    forbidden_to_remove_tab_by_filter_without_name:
        "Removing tabs from accounts {= invoiceId} is not allowed because of the filter",
    constrain_period_year:
        "Invalid field value, please enter a number between {= minConstrain } and {= maxConstrain }.",
    constrain_period_month: "Invalid field value, please enter a number between 1 and 12.",
    current_value_is_float: "You must enter an integer",
    units_numbers: "Cargo unit",
    cell_prevent_warner_window: "Column {= cell } can not be edited, since{= about }.",
    billed_invoice: " Finnish operation billed",
    checked_buy: " are jackdaws “Purchase is listed”",
    id_invoice_1c_unload_type: "The status of discharge in 1C",
    statement_date_less_than_date_in_fin_settings: ", the invoice belongs to a closed period",
    remove_linked_unit: "You removed the related goods",
    the_main_organization_is: "The parent organization is {= companyName}",
    enter_tab_name: "Enter tab's name",
    Автомобильная: "Trucking",
    Авиационная: "Air",
    Морская: "Sea",
    Железнодорожная: "Railway",
    "Таможенное оформление": "Customs clearance",
    Экспедирование: "Port forwarding",
    Перетарка: "Reloading",
    Документальная: "Documentary operation",
    Иная: "Other operation",
    multiple_default_templates_per_client: "Standard Logistics plan was already assigned to the current Customers",
    different_vats_in_fin_opers_warn: "Unable to create invoice: vats in fin. operations are different",
    different_vats_when_add_fin_oper_warn: "Cannot add fin. operation due to the vats difference",
    different_inv_pos_vats_when_add_fin_oper_warn:
        "Cannot add fin. operation due to the vats difference on invoice positions",
    documents_without_gross_weight: "Documents without gross weight: {= documentsData}",
    fin_oper_form_add_docs: "Add documents",
    add_FIN_OPERATION_ORDER_DOC_LINK: "Add documents of fin. operation",
    add_order_FIN_OPERATION_ORDER_DOC_LINK: "Add documents of fin. operation of this order",
    fin_oper_form_not_linked_order_doc: "No suitable documents found in this order",
    vat_column: "Vat",
    vat_type_column: "Type Vat",
    balance_with_counterparty_category: "Category",
    balance_with_counterparty_manager: "Manager",
    balance_with_counterparty_counterparty: "Counterparty",
    balance_with_counterparty_order: "Order",
    balance_with_counterparty_document: "Document",
    balance_with_counterparty_rate_expense_type: "Service",
    excel_file_with_translations_required: "To upload translations in Logos - excel-file with translations required",
    only_for_sys_admin: "Available only for admin user!",
    ru_system_lang_required: "To use this functionality - switch logos to RU language",
    warning_forbidden_to_edit_rec_with_linked_closed_period:
        "Cannot edit record. It's linked to manager bonus with with closed period",
    year: "Year",
    is_closing_documents_issue_1: ", closing documents are being prepaired",
    is_manager_bonus_period_close_1: ", the invoice belongs to a closed period",
    is_manager_bonus_period_close: ", the invoice belongs to a closed period",
    diffCurs: "different rates for a financial transaction: {=finOperationId}",
    diffCurrency: "different currencies for a financial transaction: {=finOperationId}",
    error_edition_railway_points: "Changing this cell is limited",
    duplicate_invoice_found: "Duplicate invoice found",
    wrong_doc_date: "Wrong doc date",
    user_operation_name: "Operations manager",
    invoice_type_2: "invoice outgoing",
    invoice_type_3: "invoice incoming money",
    invoice_type_1: "invoice incoming",
    invoice_type_4: "invoice outgoing money",
    commission_percent_is_not_create: "The commission for renomination in the contract or contracts addition has not been filled",
    nomenclature_for_renomination_is_not_filled: "Nomenclature for renomination is not filled",
    access_denied: "Access denied",
    date_type_doc_date: "Invoice date",
    date_type_planned_statement_date: "Planned statement date",
    list_tnved_code: "HS code",
    volume: "Cargo volume",
    danger_class_un_number: "Danger class, UN Number",
    country_start_name: "Country of departure",
    country_start_name_eng: "Country of departure (eng)",
    country_end_name: "Country of delivery",
    country_end_name_eng: "Country of delivery (eng)",
    units_temperature_mode_agg: "Temperature regime",
    point_start_address_eng: "Pick up place address (eng)",
    point_end_address_eng: "Delivery place address (eng)",
    point_gtd_name_eng: "Customs declaration filing place (eng)",
    point_gtd_name: "Customs declaration filing place",
    place_dimensions: "Dimensions of one place",
    unit_type_plan: "Container type",
    quantity_plan: "Container qty (potential volume)",
    note: "Note",
    logos_logout: "Exit from Logos is executed",
    forwarding_service_report: "Report by forwarding service"
};
